module.exports = function (app, mod, dev_card) {
  var html = "\n    <div class=\"saitoa dev-card-overlay\">\n      <div class=\"settlers-items-container\">";
  if (mod.canPlayerPlayCard()) {
    html += "<div class=\"settlers-item-info-text\">Select Card to Play:</div>";
  } else {
    html += "<div class=\"settlers-item-info-text\">Action Cards:</div>";
  }
  html += "<div class=\"settlers-item-row settlers-cards-container\">";
  var cards = '';
  var disable = !mod.canPlayerPlayCard();
  for (var x = 0; x < mod.game.state.players[mod.game.player - 1].devcards.length; x++) {
    var card = mod.game.deck[0].cards[mod.game.state.players[mod.game.player - 1].devcards[x]];

    //
    // It's not out turn or we have already played a dev card this turn, or which just bought the card (but it isn't a VP)
    //
    var card_disable = disable || !mod.game.state.hasRolled && card.action !== 1;
    cards += "\n \t           <div class=\"settlers-dev-card ".concat(card_disable ? 'settlers-card-disabled' : '', "\" id=\"").concat(x, "\">\n \t             \t<img src=\"").concat(card.img, "\">\n\t              <div class=\"settlers-dev-card-title\">").concat(card.card, "</div>\n\t              <div class=\"settlers-dev-card-text\">").concat(card.subtitle, "</div>\n \t           </div>\n          ");
  }

  //These are all new so disabled!
  for (var _x = 0; _x < mod.game.deck[0].hand.length; _x++) {
    var _card = mod.game.deck[0].cards[mod.game.deck[0].hand[_x]];
    cards += "\n            <div class=\"settlers-dev-card settlers-card-disabled\">\n              <img src=\"".concat(_card.img, "\">\n              <div class=\"settlers-dev-card-title\">").concat(_card.card, "</div>\n              <div class=\"settlers-dev-card-text\">").concat(_card.subtitle, "</div>\n            </div>\n          ");
  }
  if (!cards) {
    cards = "\n            <div class='player-notice'>\n\t\t\t\t\t\t\tYou don't have any cards, but can buy one with             \n              ".concat(mod.formatResource('ore'), "\n              ").concat(mod.formatResource('wheat'), "\n              ").concat(mod.formatResource('wool'), "\n            </div>\n            ");
  }
  html += cards;
  html += "\n        </div>\n      </div>\n    </div>  \n  ";
  return html;
};